import { render, staticRenderFns } from "./MubadalaForCustomer.vue?vue&type=template&id=50cf19db&"
import script from "./MubadalaForCustomer.vue?vue&type=script&lang=js&"
export * from "./MubadalaForCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports